import { render } from "./RecuperoPassword.vue?vue&type=template&id=38b1e54c"
import script from "./RecuperoPassword.vue?vue&type=script&lang=js"
export * from "./RecuperoPassword.vue?vue&type=script&lang=js"

import "./RecuperoPassword.vue?vue&type=style&index=0&id=38b1e54c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__